if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {
		constructor(){
			super();
			this.ajaxifyCartItems();
		}
		ajaxifyCartItems(){
			this.form = this.querySelector('form');
			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}
				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}
			})
		}

		updateCartQty(item, newQty){
			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}
			const body = JSON.stringify({
				// id: item.dataset.id,
				quantity: newQty,
				line: +item.dataset.line
			});
			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
			})
			.then(response => {
				if ( response.ok ) {
					return fetch('?section_id=helper-cart')
				} else {
					throw new Error('Something went wrong');
				}
			})
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					if (window.updateFreeShippingBar) {
						window.updateFreeShippingBar(cart.total_price);
					}
					if (window.updateFreeGift) {
						// 1. Filter filtered items (excluding child products)
						const ex_bd_product = cart.items.filter(item => !item.properties._child_product);
						// 2. Sum up total quantity using reduce
						const totalQuantity = ex_bd_product.reduce((sum, item) => sum + item.quantity, 0);
						// 3. Pass the total quantity to B3G1 progress bar
						window.updateFreeGift(totalQuantity);
						// window.updateFreeGift(cart.item_count); // Uses total quantity
					}
				});
				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				// Check free gift eligibility after cart update
				// if (typeof free_product_added === 'function') {
				// 	free_product_added();
				// }
			})
			.catch(e => {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove('processing');
			});
		}
	}
	if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}
}

if ( typeof CartProductQuantity !== 'function' ) {
	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  	if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}
}

// method for apps to tap into and refresh the cart
if ( ! window.refreshCart ) {
	window.refreshCart = () => {	
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();
			fetch('/cart.js')
			.then(res => res.json())
			.then(cart => {
			if (window.updateFreeShippingBar) {
				window.updateFreeShippingBar(cart.total_price);
			}
			if (window.updateFreeGift) {
				// 1. Filter filtered items (excluding child products)
				const ex_bd_product = cart.items.filter(item => !item.properties._child_product);
				// 2. Sum up total quantity using reduce
				const totalQuantity = ex_bd_product.reduce((sum, item) => sum + item.quantity, 0);
				// 3. Pass the total quantity to B3G1 progress bar
				window.updateFreeGift(totalQuantity);
				// window.updateFreeGift(cart.item_count); // Uses total quantity
			}
			});
			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			document.getElementById('site-cart-sidebar').show();
		})
	}
}

window.updateFreeShippingBar = function(cartTotalInCents) {
	// Cart total ko main currency format me convert karein (Shopify cents me return karta hai)
	const cartTotal = cartTotalInCents / 100;
	const targetAmount = 2000; // Target limit
	const shippingBar = document.getElementById('free-shipping-bar');
	const textElement = document.getElementById('free-shipping-text');
	const fillElement = document.getElementById('free-shipping-progress-fill');
	if (!shippingBar || !textElement || !fillElement) return;

	if (cartTotal >= targetAmount) {
		// Limit complete hone par
		textElement.innerHTML = '🎉 Congratulations! You’ve unlocked <strong>Free Shipping</strong>!';
		fillElement.style.width = '100%';
		fillElement.style.backgroundColor = '#4caf50'; // Green color
	} else {
		// In-progress state
		const remaining = targetAmount - cartTotal;
		const percentage = Math.min((cartTotal / targetAmount) * 100, 100);
		textElement.innerHTML = `Add <strong>Rs. ${remaining.toFixed(0)}</strong> more to get <strong>Free Shipping</strong>!`;
		fillElement.style.width = `${percentage}%`;
		fillElement.style.backgroundColor = '#ff9800'; // Orange/In-progress color
	}
};

(function () {
  var COPY = {
    empty:    'Buy 3, Get 1 <strong>Free</strong>',
    need:     'Add {x} more eligible pieces to get <strong>1 free</strong>',
    last:     'Add 1 more eligible piece — <strong>it’s free</strong>',
    unlocked: 'Unlocked! <strong>{f} free piece{s}</strong> applied at checkout',
    next:     '<strong>{f} free</strong> unlocked · add {x} more for another'
  };

  function message(qty, n) {
    var f = Math.floor(qty / n), rem = qty % n, x = n - rem;
    if (qty === 0) return COPY.empty;
    if (rem === 0) return COPY.unlocked.replace('{f}', f).replace('{s}', f > 1 ? 's' : '');
    if (f > 0) return COPY.next.replace('{f}', f).replace('{x}', x);
    return x === 1 ? COPY.last : COPY.need.replace('{x}', x);
  }

  function render(el, qty) {
    var n = parseInt(el.getAttribute('data-n'), 10) || 4;
    var prev = parseInt(el.getAttribute('data-rendered'), 10);
    var rem = qty % n;
    var filled = qty > 0 && rem === 0 ? n : rem;

    var msgEl = el.querySelector('[data-b3g1-msg]');
    if (msgEl) msgEl.innerHTML = message(qty, n);

    var segs = el.querySelectorAll('[data-b3g1-seg]');
    for (var i = 0; i < segs.length; i++) {
      segs[i].classList.toggle('is-done', i < filled);
      segs[i].classList.toggle('is-free', i === segs.length - 1);
    }

    var fill = el.querySelector('[data-b3g1-fill]');
    if (fill) fill.style.width = (filled <= 1 ? 0 : ((filled - 1) / (n - 1)) * 100) + '%';

    if (!isNaN(prev) && filled === n && prev % n !== 0) {
      el.classList.remove('is-pop');
      void el.offsetWidth;
      el.classList.add('is-pop');
    }
    el.setAttribute('data-qty', qty);
    el.setAttribute('data-rendered', qty);
  }

  // Target single or multiple progress bars on screen
  function updateFreeGift(qty) {
    var els = document.querySelectorAll('[data-b3g1]');
    for (var i = 0; i < els.length; i++) {
      render(els[i], parseInt(qty, 10) || 0);
    }
  }

  // Expose function globally for manual call
  window.updateFreeGift = updateFreeGift;
})();

document.addEventListener('DOMContentLoaded', () => {
  	fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
		if (window.updateFreeShippingBar) {
			window.updateFreeShippingBar(cart.total_price);
		}
		if (window.updateFreeGift) {
			// 1. Filter filtered items (excluding child products)
			const ex_bd_product = cart.items.filter(item => !item.properties._child_product);
			// 2. Sum up total quantity using reduce
			const totalQuantity = ex_bd_product.reduce((sum, item) => sum + item.quantity, 0);
			// 3. Pass the total quantity to B3G1 progress bar
			window.updateFreeGift(totalQuantity);
            // window.updateFreeGift(cart.item_count); // Uses total quantity
		}
    });
});

// function free_product_added() {
// 	const FIRST_VARIANT_ID = 50894971765051;  
// 	const SECOND_VARIANT_ID = 50894971797819; 
// 	const FREE_GIFT_VARIANT_IDS = [FIRST_VARIANT_ID, SECOND_VARIANT_ID];

// 	setTimeout(() => {
// 		fetch('/cart.json')
// 		.then(res => res.json())
// 		.then(data => {
// 			// Calculate cart total excluding gift items (matching Liquid template logic)
// 			let cart_item_total = 0;
// 			data.items.forEach(item => {
// 				// Exclude items with vendor "Gift" or title containing "Free" or price 0
// 				const isGift = item.vendor === 'Gift' || 
// 							   (item.vendor && item.vendor.includes('Gift')) || 
// 							   (item.title && item.title.includes('Free')) ||
// 							   FREE_GIFT_VARIANT_IDS.includes(item.variant_id);
// 				if (!isGift) {
// 					cart_item_total += item.final_line_price;
// 				}
// 			});
// 			cart_item_total = cart_item_total / 100; // Convert from cents to dollars/rupees
			
// 			const cart_free_product = data.items.find(item => FREE_GIFT_VARIANT_IDS.includes(item.variant_id));

// 			if (cart_item_total >= 2500) {
// 				if (!cart_free_product) {
// 					fetch('/cart/add.js', {
// 						method: 'POST',
// 						headers: { 'Content-Type': 'application/json' },
// 						body: JSON.stringify({
// 							items: [{ id: FIRST_VARIANT_ID, quantity: 1 }]
// 						})
// 					})
// 					.then(res => res.json())
// 					.then(response => {
// 						if (response.status === 422) {
// 							console.log('First variant sold out, trying second variant');
// 							return fetch('/cart/add.js', {
// 								method: 'POST',
// 								headers: { 'Content-Type': 'application/json' },
// 								body: JSON.stringify({
// 									items: [{ id: SECOND_VARIANT_ID, quantity: 1 }]
// 								})
// 							}).then(res => res.json());
// 						}
// 						return response;
// 					})
// 					.then(() => {
// 						console.log('Free gift added');
// 						window.refreshCart();
// 					});
// 				}
// 			} else {
// 				if (cart_free_product) {
// 					fetch('/cart/change.js', {
// 						method: 'POST',
// 						headers: { 'Content-Type': 'application/json' },
// 						body: JSON.stringify({
// 							id: cart_free_product.key,
// 							quantity: 0
// 						})
// 					})
// 					.then(res => res.json())
// 					.then(() => {
// 						console.log('Free product removed');
// 						window.refreshCart();
// 					});
// 				}
// 			}
// 		});
// 	}, 500);
// }